import { withInstall as o } from "../../utils/with-install.js";
import p from "./popup.vue.js";
/* empty css           */
const i = o(p);
export {
  i as ApPopup
};
